import { Component } from '@angular/core';
import { ForSigningModelService } from '../for-signing.model.service';

@Component({
  moduleId: module.id,
  templateUrl: 'forsigning.objects.component.html',
  providers: []
})

export class ForSigningObjectsComponent {

  model: any = {};
  errorMessage: string;

  constructor(private contractModelService: ForSigningModelService) {
  }

  ngOnInit() {
    this.model = this.contractModelService.getData();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/objects/forsigning.objects.component.ts